import DOMPurify from 'dompurify';

export const NEWS_HTML_SAFE = {
  ALLOWED_TAGS: [
    'p',
    'br',
    'strong',
    'b',
    'em',
    'i',
    'u',
    's',
    'ul',
    'ol',
    'li',
    'a',
    'h1',
    'h2',
    'h3',
    'blockquote',
    'pre',
    'code',
  ],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class'],
};

export function sanitizeNewsHtml(html) {
  if (!html || typeof html !== 'string') return '';
  const t = html.trim();
  if (!t) return '';
  return DOMPurify.sanitize(t, NEWS_HTML_SAFE);
}

/** Plain text for cards / table previews when excerpt or body is HTML. */
export function stripNewsHtmlToPlain(html) {
  if (!html || typeof html !== 'string') return '';
  const s = sanitizeNewsHtml(html).trim();
  if (!s) return '';
  if (typeof document !== 'undefined') {
    const d = document.createElement('div');
    d.innerHTML = s;
    return (d.textContent || '').replace(/\s+/g, ' ').trim();
  }
  return s.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
}

export function newsContentLooksLikeHtml(s) {
  return typeof s === 'string' && /<[a-z][\s\S]*>/i.test(s);
}
